export default __webpack_public_path__ + "media/images/mailer/wordmark-19943a5d85d7e3bef0ad1a9b18a5f98a.png";